var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadSymbol2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3555",
    "data-name": "Group 3555",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.59,
    height: 27.502,
    viewBox: "0 0 21.59 27.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10837",
    "data-name": "Rectangle 10837",
    width: 21.59,
    height: 5.08,
    transform: "translate(0 6.984)",
    fill: "#ef863a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10838",
    "data-name": "Rectangle 10838",
    width: 21.59,
    height: 5.08,
    transform: "translate(0 0)",
    fill: "#ef863a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5",
    "data-name": "Polygon 5",
    d: "M10.74,0,21.48,12.729H0Z",
    transform: "translate(21.48 27.502) rotate(180)",
    fill: "#ef863a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSymbol2);
export default __webpack_public_path__ + "static/media/Upload Symbol_2.1a6389e96fa4d70724fff85629d0a1a1.svg";
export { ForwardRef as ReactComponent };